module.exports = __webpack_public_path__ + "img/button_circle_download.c99d7b84.svg";